const SPREADSHEET_EXTENSIONS = ['.xls', '.xlsx', '.csv'];
const DOCX_MIME = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
export const isSpreadsheetFile = (file) => SPREADSHEET_EXTENSIONS.some((ext) => file.name.toLowerCase().endsWith(ext));
export const isPdfFile = (file) => file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
export const isDocxFile = (file) => file.type === DOCX_MIME || file.name.toLowerCase().endsWith('.docx');
export const classifyConsentUploadFile = (file) => {
    if (isSpreadsheetFile(file)) {
        return 'spreadsheet';
    }
    if (isPdfFile(file)) {
        return 'pdf';
    }
    if (isDocxFile(file)) {
        return 'docx';
    }
    return 'unsupported';
};
/** Library asset mimeType. Empty browser type is `application/pdf` only for a real PDF. */
export const consentAssetMimeType = (file) => {
    if (isPdfFile(file)) {
        return file.type || 'application/pdf';
    }
    return file.type;
};
